module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/products.component.scss
// module id = ./src/app/components/products/products.component.scss
// module chunks = main